<template>
  <div class="floating-container">
    <div class="floating-button">+</div>
    <div class="element-container">
      <span class="float-element tooltip-left">
        <a @click="createFile('excel')" alt="create excel file" title="create excel file" style="cursor: pointer">
          <img src="../assets/excel-icon.svg" class="icons-user" style="margin-top: -4px" />
        </a>
      </span>
      <span class="float-element tooltip-left">
        <a @click="createFile('pdf')" alt="create pdf file" title="create pdf file" style="cursor: pointer">
          <img src="../assets/pdf-icon.svg" class="icons-user" style="margin-top: -4px" />
        </a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FAB",
  props: ["filer", "excelFile", "screen", "dateValueFrom", "dateValueTo"],
  components: {},
  data() {
    return {
      name: "FAB",
    };
  },
  methods: {
    createFile: function (value) {
      let printObj = {};
      printObj.template = this.screen;
      if (value == "excel") {
        if (printObj.template == "Monitor Dashboard") {
          printObj.data = [];
          let tempSheet = {};
          let tempSheet1 = {}
          let tempData = [];
          let tempData1 = [];
          let tempExcelEntries = this.filer;
          for (let i = 0; i < tempExcelEntries.length; i++) {
            let dataTemp = {
              "VESSEL NAME": tempExcelEntries[i].Name,
              "IMO NUMBER": tempExcelEntries[i].IMO,
              "CAPACITY": tempExcelEntries[i].DeadWeight,
              // "DEAD WEIGHT": tempExcelEntries[i].DeadWeight + " mt",
              "DISTANCE TRAVELLED": tempExcelEntries[i].TotalDistance + " nm",
              "CO2 EMISSION": tempExcelEntries[i].CO2Emission + " gr",
              "ESTIMATED  CII": tempExcelEntries[i].EstimatedCII,
              "CII Δ": tempExcelEntries[i].DifferenceCIIWith2019,
              "CII Δ%": tempExcelEntries[i].DifferenceCIIWith2019PerCent,
              REFERENCE: tempExcelEntries[i].CIIref2019,
              RATING: tempExcelEntries[i].GradeRating,
            };
            tempData.push(dataTemp);
          }
          tempSheet.name = this.screen;
          tempSheet.tab = "Monitor Dashboard"
          tempSheet.data = tempData;
          printObj.data = [];
          printObj.data.push(tempSheet);

          for (let i = 0; i < tempExcelEntries.length; i++) {
            let dataTemp1 = {
              "E.M.S": "v" + process.env.VUE_APP_VERSION,
              "VESSEL NAME": tempExcelEntries[i].Name,
              "VESSEL TYPE": tempExcelEntries[i].shipDetails,
            };
            tempData1.push(dataTemp1);
          }

          tempSheet1.name = "INFO";
          tempSheet1.data = tempData1;
          printObj.data.push(tempSheet1);
          printObj.filename =
            "Monitor Dashboard-v" + process.env.VUE_APP_VERSION + "-(" +
            this.dateValueFrom +
            " - " +
            this.dateValueTo +
            ")";
        }


        if (printObj.template == "Prediction Dashboard") {
          printObj.data = [];
          let tempSheet = {};
          let tempData = [];
          let tempSheet1 = {};
          let tempData1 = [];
          let tempExcelEntries = this.filer.reports;


          for (let i = 0; i < tempExcelEntries.length; i++) {
            let dataTemp = {
              "VESSEL NAME": tempExcelEntries[i].Name,
              "IMO NUMBER": tempExcelEntries[i].IMO,
              "DEAD WEIGHT": tempExcelEntries[i].DeadWeight + " mt",
              "DISTANCE TRAVELLED": tempExcelEntries[i].TotalDistance + " nm",
              "CO2 EMISSION": tempExcelEntries[i].CO2Emission + " gr",
              "ESTIMATED  CII": tempExcelEntries[i].EstimatedCII,
              "CII 2019Δ": tempExcelEntries[i].DifferenceCIIWith2019,
              "CII 2019Δ%": tempExcelEntries[i].DifferenceCIIWith2019PerCent,
              REFERENCE: tempExcelEntries[i].CIIref2019,
              RATING: tempExcelEntries[i].GradeRating,
            };
            tempData.push(dataTemp);
          }




          tempSheet.name = this.screen;
          tempSheet.data = tempData;
          printObj.data = [];
          printObj.data.push(tempSheet);


          // CII Index Compared To Baseline

          let tempData2 = [];
          let tempSheet2 = {};
          let dataTemp2 = {};
          let tempchartDataset = this.filer.chartDataset;

          for (let i = 0; i < tempchartDataset.categories.length; i++) {
            dataTemp2 = {
              "": tempchartDataset.categories[i],
              "Attained CII": tempchartDataset.series[0].data[i],
              "Estimated CII": tempchartDataset.series[1].data[i],
              "Required CII": tempchartDataset.series[2].data[i],
            };
            tempData2.push(dataTemp2);
          }

          let tempData3 = [
            {
              "": "Diadema",
              "Attained CII": "1",
              "Estimated CII": "2",
              "Required CII": "3",
            },
            {
              "": "Serena",
              "Attained CII": "11",
              "Estimated CII": "22",
              "Required CII": "33",
            },
          ];


          tempSheet2.name = "CII Index Compared To Baseline";
          tempSheet2.data = tempData2;
          printObj.data.push(tempSheet2);


          for (let i = 0; i < tempExcelEntries.length; i++) {
            let dataTemp1 = {
              "E.M.S": "v" + process.env.VUE_APP_VERSION,
              "VESSEL NAME": tempExcelEntries[i].Name,
              "VESSEL TYPE": tempExcelEntries[i].shipDetails,
            };
            tempData1.push(dataTemp1);
          }

          tempSheet1.name = "INFO";
          tempSheet1.data = tempData1;
          printObj.data.push(tempSheet1)


          printObj.filename =
            "Prediction Dashboard(" +
            this.dateValueFrom +
            " - " +
            this.dateValueTo +
            ")";
        }

        // MONITOR DETAIL

        if (printObj.template == "Monitor Detail") {
          printObj.data = [];
          let tempSheet0 = {};
          let tempSheet1 = {};
          let tempSheet2 = {};
          let tempSheet3 = {}; //tofix
          let tempData0 = [];
          let tempData1 = [];
          let tempExcelEntries = this.filer;

          if (tempExcelEntries.multiDataset.categories.length == 0) {
            return
          }
          // CII Index Compared To Baseline



          for (
            let i = 0;
            i < tempExcelEntries.multiDataset.categories.length;
            i++
          ) {
            // alert(tempExcelEntries.multiDataset.categories[i]);
            let dateTime = tempExcelEntries.multiDataset.categories[i];
            let dataTemp0 = {};
            dateTime = dateTime.replace("T", "::");

            dataTemp0["DATE"] = dateTime;
            dataTemp0["CII"] = tempExcelEntries.multiDataset.series[0].data[i];
            dataTemp0["SOG"] = tempExcelEntries.multiDataset.series[1].data[i];


            tempData0.push(dataTemp0);
          }


          tempSheet0.name = "CII Index Compared To Baseline";
          tempSheet0.tab = "CII Index - SOG"
          // tempSheet0.tab = "CII Index - Sog - v"+process.env.VUE_APP_VERSION;
          tempSheet0.data = tempData0;
          printObj.data.push(tempSheet0);

          //CII DEcomposition
          let dataTemp1 = {};

          for (
            let i = 0;
            i < tempExcelEntries.fuelConsumptionDataset.categories.length;
            i++
          ) {
            let tempKey = tempExcelEntries.fuelConsumptionDataset.categories[i];

            dataTemp1[tempKey.toUpperCase()] =
              tempExcelEntries.fuelConsumptionDataset.series[0].data[i] + " kgr";
            dataTemp1[tempKey.toUpperCase() + "( % ) "] =
              tempExcelEntries.CIIDecomposition[i] + " %";
          }
          tempData1.push(dataTemp1);
          tempSheet1.name = "CII Decomposition";
          tempSheet1.data = tempData1;
          // printObj.data=[];
          printObj.data.push(tempSheet1);

          //CII Yearly

          let tempData2 = [];

          let dataTemp2 = {};

          for (
            let i = 0;
            i < tempExcelEntries.yearlyDataset.categories.length;
            i++
          ) {
            let tempKey = tempExcelEntries.yearlyDataset.categories[i];

            dataTemp2[tempKey.toUpperCase()] =
              tempExcelEntries.yearlyDataset.series[0].data[i];
            // + " kgr";
          }
          tempData2.push(dataTemp2);
          tempSheet2.name = "CII Yearly";
          tempSheet2.data = tempData2;
          printObj.data.push(tempSheet2);
          tempSheet3.name = "INFO";
          tempSheet3.data = [
            {
              "E.M.S": "v" + process.env.VUE_APP_VERSION,
              "NAME": tempExcelEntries.printShipDetails.shipName,
              "Type": tempExcelEntries.printShipDetails.shipType
            }
          ]
          printObj.data.push(tempSheet3);
          printObj.filename =
            "Monitor Detail(" +
            this.dateValueFrom +
            " - " +
            this.dateValueTo +
            ")";
        }

        if (printObj.template == "Prediction Detail") {
          printObj.data = [];
          let tempSheet0 = {};
          let tempSheet1 = {};
          let tempSheet2 = {};
          let tempSheet3 = {};
          let tempData0 = [];
          let tempData1 = [];
          let tempExcelEntries = this.filer;
          let numOfYears = tempExcelEntries.multiDataset.series.length


          // CII Index Compared To Baseline

          for (
            let i = 0;
            i < tempExcelEntries.multiDataset.categories.length;
            i++
          ) {
            let dateTime = tempExcelEntries.multiDataset.categories[i];
            let dataTemp0 = {};
            dataTemp0["MONTH"] = dateTime;

            dataTemp0[new Date().getFullYear()] = tempExcelEntries.multiDataset.series[0].data[i];

            if (numOfYears > 1) {
              dataTemp0[new Date().getFullYear() + 1] = tempExcelEntries.multiDataset.series[1].data[i];
            }

            if (numOfYears > 2) {
              dataTemp0[new Date().getFullYear() + 2] = tempExcelEntries.multiDataset.series[2].data[i];
            }
            tempData0.push(dataTemp0);
          }

          tempSheet0.name = "CII Index - Baseline";
          tempSheet0.data = tempData0;
          printObj.data.push(tempSheet0);

          // CII DEcomposition
          let dataTemp1 = {};

          for (
            let i = 0;
            i < tempExcelEntries.fuelConsumptionDataset.categories.length;
            i++
          ) {
            let tempKey = tempExcelEntries.fuelConsumptionDataset.categories[i];

            dataTemp1[tempKey.toUpperCase()] =
              tempExcelEntries.fuelConsumptionDataset.series[0].data[i] + " kgr";
            dataTemp1[tempKey.toUpperCase() + "( % ) "] =
              tempExcelEntries.CIIDecomposition[i] + " %";
          }
          tempData1.push(dataTemp1);
          tempSheet1.name = "CII Decomposition";
          tempSheet1.data = tempData1;
          printObj.data.push(tempSheet1);

          // CII Yearly

          let tempData2 = [];

          let dataTemp2 = {};

          for (
            let i = 0;
            i < tempExcelEntries.yearlyDataset.categories.length;
            i++
          ) {
            let tempKey = tempExcelEntries.yearlyDataset.categories[i];

            dataTemp2[tempKey.toUpperCase()] =
              tempExcelEntries.yearlyDataset.series[0].data[i];
            // + " kgr";
          }
          tempData2.push(dataTemp2);
          tempSheet2.name = "CII Yearly";
          tempSheet2.data = tempData2;
          printObj.data.push(tempSheet2);
          tempSheet3.name = "INFO";
          tempSheet3.data = [
            {
              "E.M.S": "v" + process.env.VUE_APP_VERSION,
              "NAME": tempExcelEntries.printShipDetails.shipName,
              "Type": tempExcelEntries.printShipDetails.shipType
            }
          ]
          printObj.data.push(tempSheet3);
          printObj.filename = "Prediction Detail";
        }


        //////////////////////////////////////////////////

        sessionStorage.setItem("exceldetails", JSON.stringify(printObj));
        window.open("/#/ExcelDownload", "_blank");
      } else {
        printObj.data = this.filer;
        printObj.dateValueFrom = this.dateValueFrom;
        printObj.dateValueTo = this.dateValueTo;
        sessionStorage.setItem("printdetails", JSON.stringify(printObj));
        window.open("/#/PrintPdf", "_blank");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
